import React from "react";
import { formatCurrency } from "../../../utils/utils_number";

const TotalizadoresDetalle = ({ factura }) => {
  const totalValorTributo = factura.resumen?.tributos?.reduce((acc, tributo) => acc + tributo.valor, 0);
  return (
    <div className="invoice">
      <div className="invoice-content">
        <div className="invoice-price">
          <div className="invoice-price-left">
            <div className="invoice-price-row">
              <div className="sub-price">
                <small>SUBTOTAL</small>
                <span className="text-dark"> {formatCurrency(factura.resumen.totalGravada)} </span>
              </div>

              {totalValorTributo > 0 ? (
                <>
                  <div className="sub-price">
                    <i className="fa fa-plus text-muted"></i>
                  </div>
                  <div className="sub-price">
                    <small>IVA (13%)</small>
                    <span className="text-dark"> {formatCurrency(totalValorTributo)}</span>
                  </div>
                </>
              ) : null}

              {factura.resumen.ivaRete1 > 0 ? (
                <>
                  <div className="sub-price">
                    <i className="fa fa-minus text-muted"></i>
                  </div>
                  <div className="sub-price">
                    <small>IVA Retenido(1%)</small>
                    <span className="text-dark">{formatCurrency(factura.resumen.ivaRete1)}</span>
                  </div>
                </>
              ) : null}

              {factura.resumen.totalExenta > 0 ? (
                <>
                  <div className="sub-price">
                    <i className="fa fa-plus text-muted"></i>
                  </div>
                  <div className="sub-price">
                    <small>Vtas Excentas</small>
                    <span className="text-dark"> {formatCurrency(factura.resumen.totalExenta)} </span>
                  </div>
                </>
              ) : null}

              {factura.resumen.totalNoSuj > 0 ? (
                <>
                  <div className="sub-price">
                    <i className="fa fa-plus text-muted"></i>
                  </div>
                  <div className="sub-price">
                    <small>Vtas No Sujetas</small>
                    <span className="text-dark"> {formatCurrency(factura.resumen.totalNoSuj)} </span>
                  </div>
                </>
              ) : null}
            </div>
          </div>
          <div className="invoice-price-right">
            <small>TOTAL</small> <span className="fw-bold">{formatCurrency(factura.resumen.totalPagar)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalizadoresDetalle;
